"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var strategy_1 = require("./strategy");
var util_1 = require("./util");
var STICKINESS = {
    default: 'default',
    userId: 'userId',
    sessionId: 'sessionId',
    random: 'random',
};
var FlexibleRolloutStrategy = /** @class */ (function (_super) {
    __extends(FlexibleRolloutStrategy, _super);
    function FlexibleRolloutStrategy(radnomGenerator) {
        var _this = _super.call(this, 'flexibleRollout') || this;
        _this.randomGenerator = function () { return Math.round(Math.random() * 100) + 1 + ''; };
        if (radnomGenerator) {
            _this.randomGenerator = radnomGenerator;
        }
        return _this;
    }
    FlexibleRolloutStrategy.prototype.resolveStickiness = function (stickiness, context) {
        switch (stickiness) {
            case STICKINESS.userId:
                return context.userId;
            case STICKINESS.sessionId:
                return context.sessionId;
            case STICKINESS.random:
                return this.randomGenerator();
            default:
                return context.userId || context.sessionId || this.randomGenerator();
        }
    };
    FlexibleRolloutStrategy.prototype.isEnabled = function (parameters, context) {
        var groupId = parameters.groupId || context.featureToggle || '';
        var percentage = Number(parameters.rollout);
        var stickiness = parameters.stickiness || STICKINESS.default;
        var stickinessId = this.resolveStickiness(stickiness, context);
        if (!stickinessId) {
            return false;
        }
        else {
            var normalizedUserId = util_1.normalizedValue(stickinessId, groupId);
            return percentage > 0 && normalizedUserId <= percentage;
        }
    };
    return FlexibleRolloutStrategy;
}(strategy_1.Strategy));
exports.FlexibleRolloutStrategy = FlexibleRolloutStrategy;
//# sourceMappingURL=flexible-rollout-strategy.js.map